/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Install_DesktopInputs */

const en_pc_online_cmp_install_desktop = /** @type {(inputs: Pc_Online_Cmp_Install_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installer, portable or package`)
};

const zh_pc_online_cmp_install_desktop = /** @type {(inputs: Pc_Online_Cmp_Install_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装包、便携版或软件包`)
};

/**
* | output |
* | --- |
* | "Installer, portable or package" |
*
* @param {Pc_Online_Cmp_Install_DesktopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_install_desktop = /** @type {((inputs?: Pc_Online_Cmp_Install_DesktopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Install_DesktopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_install_desktop(inputs)
	return zh_pc_online_cmp_install_desktop(inputs)
});
export { pc_online_cmp_install_desktop as "pc.online.cmp.install.desktop" }